export default __webpack_public_path__ + "static/media/mode-571.5560c566.svg";